import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoicePanelBaseProps } from "../../shared";
import { DeleteIncomingInvoice } from "./delete-incoming-invoice";
import { ResetIncomingInvoiceReview } from "./reset-incoming-invoice-review";

export function IncomingInvoiceSettingsGeneral({
	incomingInvoiceId,
}: IncomingInvoicePanelBaseProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack">
			<ContentCard
				title={t("general.danger_zone")}
				icon={icon("Skull")}
			>
				<ResetIncomingInvoiceReview incomingInvoiceId={incomingInvoiceId} />
				<DeleteIncomingInvoice incomingInvoiceId={incomingInvoiceId} />
			</ContentCard>
		</div>
	);
}
